import {ChevronDownIcon} from '@heroicons/react/24/outline'
import {Tooltip} from '@mui/material'
import {defaultImage, noImage} from 'assets/imageDeclear'
import dayjs from 'dayjs'
import {envImagePath} from 'GLOBAL/envVariables'
import CustomerNumberCell from '../components/CustomerNumberCell'

export const columnFragments = {
  check_date: {
    field: 'check_date',
    headerName: '납기일자',
    width: 100,
    align: 'center' as const,
    headerAlign: 'center' as const,
  },
  customer_number: {
    field: 'customer_number',
    headerName: '수용가번호',
    width: 200,
    align: 'center' as const,
    headerAlign: 'center' as const,
    renderCell: (params: any) => (
      <CustomerNumberCell
        value={params.row.customer_number}
        status={params.row.customer_status}
        cooper={params.row.cooper_idx}
      />
    ),
  },
  customer_info: {
    field: 'address_road',
    headerName: '수용가정보',
    width: 250,
    align: 'left' as const,
    headerAlign: 'center' as const,
    cellClassName: 'ellipsis-cell',
    renderCell: (params: any) => (
      <div className='flex flex-col w-full'>
        <span className='font-semibold'>{params.row.customer_name}</span>
        <span className='text-gray-800 whitespace-nowrap overflow-hidden text-ellipsis w-full'>
          {params.row.address_road}
        </span>
      </div>
    ),
  },
  file_path: {
    field: 'file_path',
    headerName: '지침사진',
    width: 260,
    align: 'center' as const,
    headerAlign: 'center' as const,
    renderCell: (params: any) => {
      const file_path = params.row.file_path || ''
      const imagePath = file_path.includes('/HYCHECK/')
        ? `https://api-kt.neoidm.com:8989/api${file_path}`
        : `${envImagePath}${file_path}`
      const rotate = params.row.rotate
      return (
        <>
          {params.row.process_status === 'digital' ? (
            <img className={'cursor-pointer'} src={defaultImage} alt='' />
          ) : (
            <div className={'row'}>
              <img
                alt={'device-img'}
                className={'cursor-pointer'}
                src={
                  params.row.file_path === null || params.row.process_status === 'IMGERR'
                    ? noImage
                    : imagePath
                }
                style={{
                  transform: params.row.file_path
                    ? (Number(rotate) > 90 && Number(rotate) < 270) ||
                      (Number(rotate) < -90 && Number(rotate) > -270)
                      ? `rotate(${rotate}deg)`
                      : `rotate(0deg)`
                    : `rotate(0deg)`,
                }}
                width={320}
                height={144}
              />
            </div>
          )}
        </>
      )
    },
  },
  bef_file_path: {
    field: 'bef_file_path',
    headerName: '지침사진',
    width: 260,
    align: 'center' as const,
    headerAlign: 'center' as const,
    renderCell: (params: any) => {
      const file_path = params.row.bef_file_path || ''
      const imagePath = file_path.includes('/HYCHECK/')
        ? `https://api-kt.neoidm.com:8989/api${file_path}`
        : `${envImagePath}${file_path}`
      const rotate = params.row.rotate
      return (
        <>
          {params.row.process_status === 'digital' ? (
            <img className={'cursor-pointer'} src={defaultImage} alt='' />
          ) : (
            <div className={'row'}>
              <img
                alt={'device-img'}
                className={'cursor-pointer'}
                src={
                  params.row.file_path === null || params.row.process_status === 'IMGERR'
                    ? noImage
                    : imagePath
                }
                style={{
                  transform: params.row.file_path
                    ? (Number(rotate) > 90 && Number(rotate) < 270) ||
                      (Number(rotate) < -90 && Number(rotate) > -270)
                      ? `rotate(${rotate}deg)`
                      : `rotate(0deg)`
                    : `rotate(0deg)`,
                }}
                width={320}
                height={144}
              />
            </div>
          )}
        </>
      )
    },
  },
  bef_check_code: {
    field: 'bef_check_code',
    headerName: '코드',
    width: 80,
    align: 'center' as const,
    headerAlign: 'center' as const,
  },
  bef_check_info: {
    field: 'bef_check_info',
    headerName: '검침일자',
    width: 125,
    align: 'center' as const,
    headerAlign: 'center' as const,
    renderCell: (params: any) => (
      <div className='flex flex-col justify-center items-center text-center'>
        {params.row.check_value_default === '' ? (
          <span className='text-red-600 font-bold'>인식불가</span>
        ) : (
          <div>{params.row.bef_check_value}</div>
        )}
        <div>
          {params.row.now_check_date === null && params.row.bef_check_value === null
            ? '검침정보 없음'
            : dayjs(params.row.bef_check_date).format('YYYY-MM-DD')}
        </div>
      </div>
    ),
  },
  bef_check_value: {
    field: 'bef_check_value',
    headerName: '지침',
    width: 80,
    align: 'center' as const,
    headerAlign: 'center' as const,
  },
  bef_used: {
    field: 'bef_used',
    headerName: '사용량',
    width: 80,
    align: 'center' as const,
    headerAlign: 'center' as const,
  },
  now_check_info: {
    field: 'now_check_info',
    headerName: '검침일자',
    width: 125,
    align: 'center' as const,
    headerAlign: 'center' as const,
    renderCell: (params: any) => {
      const check_day = Number(params.row.check_day)
      const now_check_date = params.row.now_check_date
        ? dayjs(params.row.now_check_date).format('YYYY-MM-DD')
        : null

      const isDigital = params.row.process_status === 'digital'
      const rawValue = params.row.check_value_default
      const decimalValue = params.row.check_decimal_value
      const displayValue =
        rawValue === null || rawValue === undefined || rawValue === ''
          ? ''
          : isDigital
          ? `${Number(rawValue)}${
              decimalValue != null ? `.${String(decimalValue).replace(/^0\./, '')}` : ''
            }`
          : rawValue

      return (
        <div className='flex flex-col justify-center items-center text-center'>
          {displayValue === '' ? (
            <span className='text-red-600 font-bold'>인식불가</span>
          ) : (
            <span>{displayValue}</span>
          )}

          <div>
            {now_check_date === null && displayValue === '' ? (
              <span className='text-orange-600 font-bold'>검침정보 없음</span>
            ) : check_day !== dayjs(params.row.now_check_date).date() ? (
              <Tooltip title={`등록 검침일: ${params.row.check_day}일`}>
                <span className='text-orange-600 font-bold'>{now_check_date}</span>
              </Tooltip>
            ) : (
              <span className='font-bold'>{now_check_date}</span>
            )}
          </div>
        </div>
      )
    },
  },
  now_check_code: (selectOption: any, handleInputChange: any) => {
    return {
      field: 'now_check_code',
      headerName: '검침코드',
      width: 150,
      align: 'center' as const,
      headerAlign: 'center' as const,
      renderCell: (params: any) => {
        const isDigital = params.row.process_status === 'digital'

        return (
          <div className='relative w-full'>
            <select
              value={params.row.now_check_code ?? ''}
              disabled={isDigital}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => {
                if (!isDigital) {
                  const value = e.target.value
                  handleInputChange(params.row.id, 'now_check_code', value)
                }
              }}
              className={`block w-full appearance-none rounded-lg border px-4 py-4 pr-10 
              focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500
              ${
                isDigital
                  ? 'bg-gray-100 text-gray-500 border-gray-300 cursor-not-allowed'
                  : 'bg-white text-gray-700 border-gray-300'
              }`}
            >
              {selectOption.map((option: any) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <div
              className={`pointer-events-none absolute inset-y-0 right-3 flex items-center ${
                isDigital ? 'text-gray-400' : 'text-gray-500'
              }`}
            >
              <ChevronDownIcon className='w-5 h-5' />
            </div>
          </div>
        )
      },
    }
  },
  check_value: (handleInputChange: any) => {
    return {
      field: 'check_value',
      headerName: '지침',
      width: 150,
      align: 'center' as const,
      headerAlign: 'center' as const,
      renderCell: (params: any) => {
        const rawValue = params.row.check_value ?? params.row.check_value_default
        const decimalValue = params.row.check_decimal_value

        const displayValue =
          rawValue === null || rawValue === undefined || rawValue === ''
            ? ''
            : params.row.process_status === 'digital'
            ? `${Number(rawValue)}${
                decimalValue != null ? `.${String(decimalValue).replace(/^0\./, '')}` : ''
              }`
            : String(Number(rawValue))

        const isDigital = params.row.process_status === 'digital'

        return (
          <input
            type='text'
            value={displayValue}
            disabled={isDigital} // digital이면 수정 불가
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => {
              if ((e.ctrlKey || e.metaKey) && e.key === 'a') {
                e.preventDefault()
                e.stopPropagation()
                ;(e.target as HTMLInputElement).select()
              }
            }}
            onChange={(e) => {
              if (!isDigital) {
                const input = e.target.value
                const onlyNumbers = /^[0-9]*$/
                if (onlyNumbers.test(input)) {
                  handleInputChange(params.row.id, 'check_value', input)
                }
              }
            }}
            className={`w-full px-4 py-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              isDigital ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : ''
            }`}
            maxLength={8}
          />
        )
      },
    }
  },
  now_used: {
    field: 'now_used',
    headerName: '사용량',
    width: 150,
    align: 'center' as const,
    headerAlign: 'center' as const,
    renderCell: (params: any) => {
      const checkValue =
        params.row.check_value === null || params.row.check_value === ''
          ? Number(params.row.check_value_default)
          : Number(params.row.check_value)

      const befValue = Number(params.row.bef_check_value)
      const used = isNaN(checkValue - befValue) ? '' : checkValue - befValue

      // 조건부 Tailwind 클래스
      const isNegative = typeof used === 'number' && used < 0
      const inputClass = `w-full px-4 py-4 border rounded-lg bg-gray-100 ${
        isNegative ? 'border-red-300 bg-red-100 text-red-700' : 'border-gray-300'
      }`

      return <input type='text' value={used} readOnly className={inputClass} />
    },
  },
  check_user: {
    field: 'check_user',
    headerName: '수정자',
    width: 125,
    align: 'center' as const,
    headerAlign: 'center' as const,
  },
  edited_status: (officeCode: string) => ({
    field: 'edited_status',
    headerName: '비고',
    width: 120,
    align: 'center' as const,
    headerAlign: 'center' as const,

    renderCell: (params: any) => {
      let shortText = ''
      let fullText = ''

      const getLeakStatus = (row: any, officeCode: string) => {
        // Z200이 아닌 경우 기존 DB leak_status 사용
        if (officeCode !== 'Z200') {
          return row.leak_status === true
        }

        const averageUsed = Number(row.now_check_quantity)

        let nowUsed: number

        if (row.now_used === null || row.now_used === undefined || row.now_used === '') {
          // 저장 전
          const checkValue =
            row.check_value === null || row.check_value === ''
              ? Number(row.check_value_default)
              : Number(row.check_value)

          const befCheckValue = Number(row.bef_check_value)

          nowUsed = checkValue - befCheckValue
        } else {
          nowUsed = Number(row.now_used)
        }

        return !isNaN(nowUsed) && !isNaN(averageUsed) && nowUsed >= averageUsed * 1.2
      }

      switch (params.row.charge_status) {
        case 'NO_BEF':
          shortText = '전불'
          fullText = '전월지침 확인불가'
          break

        case 'NO_CURR':
          shortText = '당불'
          fullText = '당월지침 확인불가'
          break

        case 'ABNORMAL':
          shortText = '확인필요'
          fullText = '지침 확인필요'
          break

        case 'MINUS':
          shortText = '음수'
          fullText = '사용량 음수'
          break

        case 'BEF_DAY':
          shortText = '이전'
          fullText = '등록 검침일보다 이전'
          break

        case 'AFT_DAY':
          shortText = '이후'
          fullText = '등록 검침일보다 이후'
          break

        default: {
          const leakStatus = getLeakStatus(params.row, officeCode)

          if (leakStatus) {
            shortText = '이상증가'

            fullText =
              officeCode === 'Z200'
                ? '3개월 평균 사용량 대비 20% 이상 증가'
                : '전월 사용량 대비 20% 이상 증가'
          } else if (params.row.charge_status === 'MOVE') {
            shortText = '이동'
            fullText = '이동 처리됨'
          }

          break
        }
      }

      const isEdited = params.row.edited_status === true

      return (
        <Tooltip
          title={fullText}
          arrow
          placement='top'
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: '16px',
              },
            },
          }}
        >
          <span>
            {shortText}

            {isEdited && <span className='text-green-600'>{shortText ? ' (수정)' : '수정'}</span>}
          </span>
        </Tooltip>
      )
    },
  }),
}
